import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

import { ReactComponent as Money } from 'assets/images/money.svg';

export const ExtraChargeWrapper = styled.div`
  display: flex;
  margin: 8px 0 0;
`;

export const MoneyIcon = styled(Money)`
  width: 16px;
  height: 16px;
  margin-top: 4px;
  margin-right: 10px;
`;

export const ExtraChargeName = styled.p`
  font-size: 16px;
  font-weight: 600;
  line-height: 1.5;
  color: ${ColorPalette.HEX.CharlestonGreen};
`;

export const Info = styled.span`
  display: flex;
  font-size: 14px;
  color: ${ColorPalette.HEX.DimGray};
  padding: 4px 0 0 0px;
`;
